import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	root: {

	},
	headerActions: {
		textAlign: 'right',
	},
	vertHeaderActions: {
		textAlign: 'center',
		marginLeft: '-8px'
	},
	createContentButton: {
		/*marginRight: theme.spacing.unit * 2,*/
	},
	headerTitle: {
	},
	breadSyllabus: {
		padding: "5px 10px 5px 10px", 
		borderRadius: "40px", 
		border: "1px solid #DFDFDF", 
		backgroundColor: "#DFDFDF", 
		marginLeft: "5px",
		color: "rgba(0, 0, 0, 0.543846)",
		fontSize:"12px"
	},
	breadSyllabusResult: {
		padding: "5px 10px 5px 10px", 
		borderRadius: "40px", 
		marginLeft: "5px",
		color: "rgba(0, 0, 0, 0.543846)",
		fontSize:"12px"
	},
	floatLeft:{
		float:"right",
		marginLeft:"20px"
	}
});
